const color = {
  text_300: "#7F7F7F",
  text_500: "#000000",
  background: "#55b7de",
};

const size = {
  display_1: `3.875rem`,
  display_2: `3.375rem`,
  heading_1: `2.875rem`,
  heading_2: `2.375rem`,
  heading_3: `1.875rem`,
  heading_4: `1.625rem`,
  heading_5: `1.375rem`,
  heading_6: `1.125rem`,
  subtitle_1: `1rem`,
  subtitle_2: `0.875rem`,
  body_1: `0.875rem`,
  body_2: `0.75rem`,
  body_3: `0.625rem`,
  button_1: `0.875rem`,
  button_2: `0.75rem`,
  caption: `0.625rem`,
};

const weight = {
  bold: 800,
  medium: 600,
  regular: 500,
  light: 300,
  thin: 100,
};

const font = {
  size,
  weight,
};

const grid = {
  mobile: `(max-width: 480px)`,
  tablet: `(max-width: 767px)`,
  laptop: `(max-width: 1440px)`,
  desktop: `(max-width: 1920px)`,
};

export const theme = {
  color,
  grid,
  font,
};

export type Theme = typeof theme;
type ColorObject = typeof color;
export type Color = keyof ColorObject;
